import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { JobLabelComponent } from './job-label.component';
import { JobOptionComponent } from './job-option.component';

@NgModule({
  declarations: [JobLabelComponent, JobOptionComponent],
  imports: [CommonModule, TooltipModule],
  exports: [JobLabelComponent, JobOptionComponent],
})
export class JobLabelModule {}
